export default "__VITE_ASSET__b3ff25b9__"